/**
 * File: adminTabsData.ts
 * Path: apps/admin/src/modules/layout/utils/adminTabsData.ts
 * Description: The plain-text, gold-underline tab bar every admin page uses,
 * for pages built on the Radix Tabs parts (TabsList and TabsTrigger). It is
 * the same look as `tabClass` in accounting/pages/tabClass.ts, which the
 * pages that switch tabs by hand use.
 */

export const TAB_LIST_CLASS =
  "h-auto w-full justify-start gap-stack-xs overflow-x-auto rounded-none border-b border-border/50 bg-transparent p-0";

export const TAB_TRIGGER_CLASS =
  "min-h-11 shrink-0 whitespace-nowrap rounded-none border-b-2 border-transparent bg-transparent px-stack-sm py-0 text-sm font-medium text-muted-foreground shadow-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none";
